import httpClient from '../config/httpClient';
import firebase from '../config/firebase.config';
import {
  subscribeToIntegrationImportLogs,
  getIntegrationImportLogDetails,
} from './integrationImport';

export const getQuickBooksAuthUrl = async (companyId, userId) => {
  const { data } = await httpClient.post('/quickbooksTimeGetAuthUrl', {
    companyId,
    userId,
  });
  return data;
};

export const disconnectQuickBooks = async (companyId, userId) => {
  const { data } = await httpClient.post('/quickbooksTimeDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getQuickBooksEmployees = async (companyId) => {
  const { data } = await httpClient.post('/quickbooksGetEmployees', {
    companyId,
  });
  return data;
};

export const getQuickBooksCustomers = async (companyId) => {
  const { data } = await httpClient.post('/quickbooksGetCustomers', {
    companyId,
  });
  return data;
};

export const autoMapQuickBooksEmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/quickbooksAutoMapEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const exportAllEmployeesToQuickBooks = async (companyId, teamId) => {
  const { data } = await httpClient.post('/quickbooksExportAllEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const createAndMapQuickBooksEmployee = async (
  companyId,
  prodaffUserId,
  displayName,
  email
) => {
  const { data } = await httpClient.post('/quickbooksCreateAndMapEmployee', {
    companyId,
    prodaffUserId,
    displayName,
    email,
  });
  return data;
};

export const saveQuickBooksMappings = async (companyId, mappings) => {
  const { data } = await httpClient.post('/quickbooksSaveMappings', {
    companyId,
    mappings,
  });
  return data;
};

export const syncQuickBooksTimeRange = async (
  companyId,
  teamId,
  startDate,
  endDate
) => {
  const { data } = await httpClient.post('/quickbooksSyncTimeRange', {
    companyId,
    teamId,
    startDate,
    endDate,
  });
  return data;
};

export const importQuickBooksEmployees = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/quickbooksImportEmployees', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const previewQuickBooksImport = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/quickbooksPreviewImport', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const subscribeToQBImportLogs = (companyId, onUpdate) =>
  subscribeToIntegrationImportLogs(companyId, 'quickbooksTime', onUpdate);

export const getQBImportLogDetails = (companyId, logId) =>
  getIntegrationImportLogDetails(companyId, 'quickbooksTime', logId);

export const subscribeToQBStatus = (companyId, onUpdate) => {
  return firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .collection('integrations')
    .doc('quickbooksTime')
    .onSnapshot(
      (doc) => {
        if (!doc.exists || !doc.data().connected) {
          onUpdate({
            connected: false,
            realmId: null,
            connectedAt: null,
            connectedBy: null,
            employeeMappings: {},
            employeeMappingsUpdatedAt: null,
            lastSyncAt: null,
            lastSyncStats: null,
          });
          return;
        }
        const d = doc.data();
        onUpdate({
          connected: true,
          realmId: d.realmId || null,
          connectedAt: d.connectedAt?.toDate?.() ?? null,
          connectedBy: d.connectedBy || null,
          employeeMappings: d.employeeMappings || {},
          employeeMappingsUpdatedAt:
            d.employeeMappingsUpdatedAt?.toDate?.() ?? null,
          lastSyncAt: d.lastSyncAt?.toDate?.() ?? null,
          lastSyncStats: d.lastSyncStats || null,
        });
      },
      (err) => {
        console.error('QB status listener error:', err);
        onUpdate({
          connected: false,
          realmId: null,
          connectedAt: null,
          connectedBy: null,
          employeeMappings: {},
          employeeMappingsUpdatedAt: null,
          lastSyncAt: null,
          lastSyncStats: null,
        });
      }
    );
};
